module.exports = __webpack_public_path__ + "img/Katarina_acc_07.15e51ecc.jpg";